export default (that) => [
  {
    text: that.$l('menu_label_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_label_edit_sample') || '编辑展品',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'F',
    disabled: ({ expoSampleStatus }) => expoSampleStatus !== 'N',
  },
  {
    text: that.$l('menu_label_delete_sample') || '删除选品',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'G',
    disabled: ({ expoSampleStatus }) => expoSampleStatus !== 'N',
  },
  {
    text: that.$l('menu_label_audit_sample') || '展品审核',
    icon: 'el-icon-check',
    menuType: 'audit',
    divided: true,
    allow: 'H',
    disabled: ({ expoSampleStatus }) => expoSampleStatus !== 'N',
  },
  {
    text: that.$l('menu_label_change_sample') || '变更展品',
    icon: 'el-icon-edit-outline',
    menuType: 'change',
    allow: 'I',
    disabled: ({ expoSampleStatus }) => expoSampleStatus !== 'Y',
  },
  {
    text: that.$l('menu_label_printer_sample') || '标签打印',
    icon: 'el-icon-printer',
    menuType: 'printer',
    divided: true,
    allow: 'J',
    disabled: ({ expoSampleStatus }) => expoSampleStatus !== 'Y',
  },
]
